const USER_AGENT_MAP = {
  Mozilla: 'Web Browser',
  APN: 'Terraform',
};

export const formatUserAgent = (userAgentString: string): string => {
  const userAgentPrefix = userAgentString.split('/');
  return USER_AGENT_MAP[userAgentPrefix[0] as keyof typeof USER_AGENT_MAP] || userAgentPrefix[0] || 'unknown';
};
